import "react";
import e from "./index148.mjs";
import { Global as l } from "./index438.mjs";
import { j as p } from "./index58.mjs";
function f(t) {
  return t == null || Object.keys(t).length === 0;
}
function i(t) {
  const {
    styles: o,
    defaultTheme: r = {}
  } = t, n = typeof o == "function" ? (s) => o(f(s) ? r : s) : o;
  return /* @__PURE__ */ p.jsx(l, {
    styles: n
  });
}
process.env.NODE_ENV !== "production" && (i.propTypes = {
  defaultTheme: e.object,
  styles: e.oneOfType([e.array, e.string, e.object, e.func])
});
export {
  i as default
};
